import React from 'react'

const CancellationAndRefund = () => {
  return (
    <section className="section-one">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
              <p>
                Thank you for choosing Village Zone for purchasing homemade products.
                We strive to provide a seamless shopping experience and want you to be satisfied with your purchases.
                This Cancellation and Refund Policy outlines our procedures for cancellations and refunds.
              </p>

              <h4>1. Cancellation Policy:</h4>
              <ul>
                <li>
                  <strong>1.1 Cancellation by Customer:</strong> You may cancel your order at any time before it has been shipped.
                  To cancel your order, please contact our customer support team as soon as possible with your order details.
                  We will make every effort to accommodate your request, but please note that once an order has been shipped, it cannot be cancelled.
                </li>
                <li>
                  <strong>1.2 Cancellation by Village Zone:</strong> We reserve the right to cancel any order for any reason,
                  including but not limited to product unavailability, errors in pricing or product descriptions, or suspicion of fraudulent activity.
                  If we cancel your order, we will notify you promptly and provide a full refund of any payments made.
                </li>
              </ul>

              <h4>2. Refund Policy:</h4>
              <ul>
                <li>
                  <strong>2.1 Refund Eligibility:</strong> Refunds will be issued in accordance with the following conditions:
                  <ul>
                    <li>If you cancel your order before it has been shipped, we will provide a full refund of the purchase price and any applicable taxes.</li>
                    <li>If you receive damaged, defective, or incorrect products, please contact our customer support team within 15 days of receipt to arrange for a replacement or refund.</li>
                    <li>Refunds may take up to 15 business days to process and will be issued using the original payment method.</li>
                  </ul>
                </li>
                <li>
                  <strong>2.2 Refund Process:</strong> To request a refund, please contact our customer support team with your order details and the reason for the refund request.
                  We may require additional information or documentation to process your request. Once your request has been approved, we will initiate the refund process.
                </li>
                <li>
                  <strong>2.3 Non-Refundable Items:</strong> Certain items may not be eligible for refunds, including but not limited to:
                  <ul>
                    <li>Products that have been used, opened, or damaged after receipt.</li>
                    <li>Products that are perishable or cannot be resold for health or safety reasons.</li>
                    <li>Customized or personalized products made to your specifications.</li>
                  </ul>
                </li>
              </ul>

              <h4>3. Contact Us:</h4>
              <p>
                If you have any questions or concerns about our Cancellation and Refund Policy, please contact us at info@rastelx.com.
                Our customer support team is available to assist you with any inquiries or issues you may have.
              </p>
              <p>
                By using our e-commerce platform and making purchases, you acknowledge that you have read,
                understood, and agreed to the terms of this Cancellation and Refund Policy.
              </p>
              <p>This policy is effective as of 2024-05-10</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CancellationAndRefund